import web from "../web";

class TypesinscriptionsService {
    index(token){
        return web.get("/api/typesinscriptions", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/typesinscriptions", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/typesinscriptions/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/typesinscriptions/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/typesinscriptions/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    getByLibelle(libelle,token){
        return web.get(`/api/typesinscriptions/${libelle}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new  TypesinscriptionsService()